// extracted by mini-css-extract-plugin
module.exports = {"description":"ModalEventConfirmation_description_3EzCv","info":"ModalEventConfirmation_info_2zMgT"};